import { Box, createStyles, Grid, makeStyles, Theme } from "@material-ui/core";
import moment from "moment";
import { GridItemProps } from "../models/GridItemProps";
import { InvoiceType } from "../models/InvoiceDTO";
import { InvoiceProps } from "../models/InvoiceProps";
import { GetLabels } from "../utils/InvoiceLabels";
import { withLineBreaks } from "../utils/utils";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    box: {
      marginTop: theme.spacing(3)
    },
    marginTopMd: {
      height: 'fit-content',
    },
    [theme.breakpoints.down('xs')]: {
      box: {
        flexDirection: 'column',
        '& > *': {
          justifyContent: 'center'
        }
      },
      textCentre: {
        textAlign: 'center'
      },
      marginTopMd: {
        marginTop: theme.spacing(3)
      }
    }
  })
);

const GridItem : React.FunctionComponent<GridItemProps> = ({label, value}) => {
    return (
      <>
        <Grid item xs={6}>
            {label} :
        </Grid>
        <Grid item xs={5}>
            {value}
        </Grid>
      </>
    );
}

const InvoiceInfo : React.FunctionComponent<InvoiceProps> = ({ invoice }) => {

  const classes = useStyles();
  const { id, orderNumber, dueDate, invoiceDate, to, type } = invoice!;
  const isCredit = type === InvoiceType.Credit;
  const labels = GetLabels(invoice);
  const isGuest = invoice.isGuest;

  return (
    <Box p={1} display="flex" className={classes.box}>

        {isGuest &&
          <Grid item xs={12} sm={4} md={5} lg={3} container className={classes.textCentre}>
              <GridItem label={labels.label} value={id} />
          </Grid>
        }

        {!isGuest && 
          <>
            <Grid item xs={12} sm={8} md={10} className={classes.textCentre}>
                {withLineBreaks(to)}
            </Grid>

            <Grid item xs={12} sm={8} md={5} lg={4} container className={classes.marginTopMd}>
              <GridItem label={labels.label} value={id} />
              <GridItem label={labels.dateLabel} value={moment(invoiceDate).format('Do MMM YYYY')}/>
              {!isCredit && <GridItem label={labels.paymentDateLabel} value={moment(dueDate).format('Do MMM YYYY')}/> }
              { orderNumber && <GridItem label='Customer reference' value={orderNumber}/> }
            </Grid>
          </>
        }
    </Box>
  );
}

export default InvoiceInfo;
